
    import {
        defineComponent, toRefs, computed, unref, ComputedRef,
    } from 'vue';

    import useDirectFlightFilter from './use/useDirectFlightFilter';
    import DirectFlightFilter from './DirectFlightFilter.vue';

    interface IDirectFlightFilterHotelReturn {
        isDirectFlightFilterShow: ComputedRef<boolean>,
    }

    export default defineComponent({
        name: 'direct-flight-filter-hotel',
        components: {
            DirectFlightFilter,
        },
        props: {
            selected: {
                type: Boolean,
            },
        },
        setup(props): IDirectFlightFilterHotelReturn {
            const {
                isPairOfDepartureCityAndArrivalCountryAreValid,
            } = useDirectFlightFilter();

            const isDirectFlightFilterShow = computed(() => unref(isPairOfDepartureCityAndArrivalCountryAreValid));

            return {
                isDirectFlightFilterShow,
            };
        },
    });
